import {Component, Vue} from "vue-property-decorator";
import {Column} from "~/components/grid/column";
import {TextFilter} from "~/components/text-filter";
import {Columns} from "~/components/grid/columns";
import {ClientsTable} from "~/modules/partner/components/clients-table";
import {getPartnerClients} from "~/modules/partner/services";
import type {PartnerClientDto} from "~/lib/models/app-settings";

@Component
class ClientsList extends Vue {

  private clients: PartnerClientDto[] = null;
  private textFilter = "";

  async created() {
    try {
      this.clients = await getPartnerClients();
    } catch (err) {
      this.$notify.error(`Getting clients partner failed.`);
      console.error(err.message);
    }
  }

  render() {
    return (
      <div>
        <Columns>
          <Column>
            <TextFilter v-model={this.textFilter}  placeholder="Rechercher"  />
          </Column>
        </Columns>

        {this.clients && <ClientsTable clients={this.clients.filter((c) => String(c.name).toLocaleLowerCase().includes(this.textFilter.toLocaleLowerCase()))} />}
      </div>
      )
  }
}

export { ClientsList }

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-00e0cae0/clients-list.tsx" });